import Header from "../components/header";
import Footer from "../components/footer";
import "./privacy.css";

const SECTIONS = [
  {
    title: "1. Information We Collect",
    body: (
      <>
        <p>When you register or interact with our platform, we may collect:</p>
        <ul>
          <li>Full Name</li>
          <li>CNIC Number</li>
          <li>Phone Number</li>
          <li>WhatsApp Number</li>
          <li>Email Address</li>
          <li>Province, City, and Location</li>
          <li>Profile Information</li>
          <li>Any information you voluntarily provide</li>
        </ul>
        <p>
          We may also automatically collect IP address, browser type, device
          information, usage statistics, and cookies / session data.
        </p>
      </>
    ),
  },
  {
    title: "2. How We Use Your Information",
    body: (
      <>
        <p>Your information is used only for legitimate purposes, including:</p>
        <ul>
          <li>Creating and managing your membership account</li>
          <li>Verifying your identity</li>
          <li>Contacting you regarding your membership</li>
          <li>Sending important announcements</li>
          <li>Providing updates about Technology Movement Pakistan</li>
          <li>Improving our services</li>
          <li>Preventing fraud and maintaining security</li>
        </ul>
      </>
    ),
  },
  {
    title: "3. Marketing & Communication",
    body: (
      <>
        <p>
          By creating an account, you agree that we may send you newsletters,
          event invitations, campaign updates, membership announcements,
          promotional messages, educational content, and
          SMS / WhatsApp / Email communications.
        </p>
        <p>
          You may unsubscribe from marketing emails at any time by following
          the unsubscribe instructions included in our emails.
        </p>
      </>
    ),
  },
  {
    title: "4. Data Sharing",
    body: (
      <>
        <p>We respect your privacy. We <strong>DO NOT</strong>:</p>
        <ul>
          <li>Sell your personal information</li>
          <li>Rent your personal information</li>
          <li>Share your information with advertisers</li>
          <li>Share your information with any third-party applications</li>
        </ul>
        <p>
          Your personal information remains confidential and is used solely by
          Technology Movement Pakistan for its official activities.
        </p>
      </>
    ),
  },
  {
    title: "5. Data Security",
    body: (
      <p>
        We take reasonable technical and organizational measures to protect your
        personal information against unauthorized access, loss, theft, misuse,
        disclosure, and alteration. Although we strive to protect your
        information, no internet transmission or electronic storage method is
        completely secure.
      </p>
    ),
  },
  {
    title: "6. Cookies",
    body: (
      <p>
        Our platform may use cookies to improve functionality, remember your
        preferences, enhance user experience, and analyze performance. You can
        disable cookies through your device or browser settings.
      </p>
    ),
  },
  {
    title: "7. Data Retention",
    body: (
      <p>
        We retain your information only for as long as necessary to maintain
        your membership, fulfill legal obligations, resolve disputes, and
        improve our services.
      </p>
    ),
  },
  {
    title: "8. Your Rights",
    body: (
      <>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal information</li>
          <li>Request corrections to inaccurate information</li>
          <li>Update your profile information</li>
          <li>Request permanent deletion of your account</li>
          <li>Opt out of marketing communications</li>
        </ul>
        <p>
          To exercise these rights, contact us at{" "}
          <a href="mailto:info@tmpak.pk">info@tmpak.pk</a>
        </p>
      </>
    ),
  },
  {
    title: "9. Children's Privacy",
    body: (
      <p>
        Our services are intended for individuals legally eligible to
        participate in our movement. We do not knowingly collect personal
        information from children without appropriate consent.
      </p>
    ),
  },
  {
    title: "10. Changes to This Policy",
    body: (
      <p>
        We may update this Privacy Policy from time to time. Any changes will
        be reflected with an updated effective date. Continued use of our
        services constitutes acceptance of the updated policy.
      </p>
    ),
  },
  {
    title: "11. Contact Us",
    body: (
      <div className="pp-contact">
        <p><strong>Technology Movement Pakistan</strong></p>
        <p>Website: <a href="https://tmpak.pk" target="_blank" rel="noreferrer">https://tmpak.pk</a></p>
        <p>Email: <a href="mailto:info@tmpak.pk">info@tmpak.pk</a></p>
        <p>Address: 4th Floor, Karachi Electronic Market, Sadar, Karachi</p>
        <p>Phone: 0300-5084301 &nbsp;|&nbsp; 0323-5251143</p>
      </div>
    ),
  },
];

export default function Privacy() {
  return (
    <div className="pp-root">
      <Header />

      {/* Hero */}
      <div className="pp-hero">
        <div className="pp-hero-inner">
          <span className="pp-eyebrow">Effective: June 24, 2025</span>
          <h1 className="pp-headline">Privacy Policy</h1>
          <p className="pp-sub">
            Technology Movement Pakistan is committed to protecting the privacy
            and security of every member. This policy explains what we collect,
            why, and how we use it.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="pp-body">
        <div className="pp-intro">
          <p>
            At Technology Movement Pakistan (TMP), we place great emphasis on
            privacy and its sanctity. We respect the right of Pakistani
            citizens to privacy and are committed to transparency about how we
            collect and handle personal information. This Privacy Policy applies
            to our website (<a href="https://tmpak.pk">tmpak.pk</a>) and our
            mobile application available on the Apple App Store and Google Play
            Store.
          </p>
        </div>

        {SECTIONS.map((sec, i) => (
          <div className="pp-section" key={i}>
            <h2 className="pp-section-title">{sec.title}</h2>
            <div className="pp-section-body">{sec.body}</div>
          </div>
        ))}

        <div className="pp-footer-note">
          <p>
            By using the TMP application or website, you acknowledge that you
            have read and understood this Privacy Policy and agree to its terms.
          </p>
          <p className="pp-updated">Last updated: June 24, 2025</p>
        </div>
      </div>

      <Footer />
    </div>
  );
}
